import styled, { css } from 'styled-components';
import MuiDialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import Button from '@material-ui/core/Button';

const PlDialog = styled(MuiDialog)`
  && {
    .MuiDialog-paper {
      box-shadow: 0px 8px 16px rgba(32, 33, 36, 0.15);
      min-width: 672px;
      ${({ theme: { mui } }) => css`
        ${mui.breakpoints.down('sm')} {
          width: 100%;
          min-width: 100%;
          height: 100%;
          min-height: 100%;
        }
      `}
    }
  }
`;

const PlTitleDialog = styled(MuiDialogTitle)`
  && {
    padding: 31px 24px 0px 24px;
    position: relative;
    text-align: center;
    margin-top: 20px;
    button {
      position: absolute;
      top: 75%;
      transform: translateY(-50%);
      right: 19px;
    }

    ${({ theme: { mui } }) => css`
      ${mui.breakpoints.down('sm')} {
        padding: 31px 24px 0px 24px;
        button {
          top: 75%;
          right: 3px;
        }
      }
    `}
  }
`;

const Title = styled.div`
  ${({ theme: { font } }) => font.mainFont()};
  color: ${({ theme: { color } }) => color.gray_700};
  font-weight: 500;
  font-size: 18px;
  line-height: 31px;
`;

const SubTitle = styled.div`
  color: ${({ theme: { color } }) => color.gray_400};
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  text-align: center;
  margin-top: 5px;
`;

const PlDialogContent = styled(MuiDialogContent)<{ isreceipt: string }>`
  && {
    border-color: ${({ theme: { color } }) => color.white_700};
    margin: 0 32px;
    padding: 24px 0;

    ${({ isreceipt, theme: { mui } }) => {
      if (isreceipt === 'true') {
        return css`
          ${mui.breakpoints.down('sm')} {
            margin: 0 !important;
          }
        `;
      }
      return css`
        ${mui.breakpoints.down('sm')} {
          margin: 0 16px;
        }
      `;
    }}
  }
`;

const CancelWrapper = styled.div`
  display: flex;
  flex-flow: column wrap;
  justify-content: center;
`;

const CancelButton = styled(Button)`
  && {
    .MuiButton-label {
      font-size: ${({ theme }) => theme.typography.button};
      color: ${({ theme }) => theme.color.PLColor1};
      font-weight: 700;
    }
  }
`;

export { PlDialog, PlTitleDialog, Title, PlDialogContent, CancelWrapper, CancelButton, SubTitle };
